var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-block"},[(this.info)?_c('div',{staticClass:"heading"},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.toolTip)?_c('img',{attrs:{"src":_vm.getImage('question-icon.svg'),"alt":""},on:{"click":_vm.openPopup}}):_vm._e()]):_c('div',{staticClass:"heading"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }